import React, { Component } from 'react';
import { Modal, Header, Button } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { submit } from 'redux-form';

import { IPRangeFieldEnum } from 'Common/FieldEnum';
import { IPRANGE_ENTRY_FORM_NAME } from 'Common/FormEnum';
import { IPRangeEntryForm } from './IPRangeEntryForm';

class IPRangeEntryModalContainer extends Component {
  static propTypes = {
    rowData: PropTypes.object,
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    onSubmit: PropTypes.func,
    onMyIPRequest: PropTypes.func,
    myIPDisabled: PropTypes.bool,
  };

  static defaultProps = {
    isOpen: false,
  };

  state = {
    isValid: true,
  };

  render() {
    const {
      isOpen,
      onClose,
      rowData,
      isReadOnly,
      onSubmit,
      onMyIPRequest,
      myIPDisabled,
      submit,
    } = this.props;

    const isNew = !rowData || !rowData[IPRangeFieldEnum.Id];

    return (
      <Modal open={isOpen} onClose={onClose} size="large" closeIcon>
        <Header content={`${isNew ? 'Add' : 'Edit'} IP Range`} icon="signup" />

        <Modal.Content className="p-t-0">
          <Modal.Description>
            <IPRangeEntryForm
              onSubmit={onSubmit}
              onMyIPRequest={onMyIPRequest}
              myIPDisabled={myIPDisabled}
              initialValues={rowData}
            />
          </Modal.Description>
        </Modal.Content>

        <Modal.Actions>
          <Button
            inverted
            color="orange"
            size="big"
            content="Save"
            onClick={() => submit(IPRANGE_ENTRY_FORM_NAME)}
            disabled={isReadOnly || !this.state.isValid}
          />
        </Modal.Actions>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({});
const mapDispatchToProps = { submit };

export const IPRangeEntryModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(IPRangeEntryModalContainer);



// WEBPACK FOOTER //
// ./src/pages/networkfiltering/components/IPRangeEntryModal.js